import { useState } from "react";
import { renderLineBreaks } from "../../../utils";
import { ChevronUp, ChevronDown } from "../../../lib/icons";
import {
  TitleWrapper,
  Description,
  SeoContentItemWrapper,
  ContentWrapper,
} from "./styles";

const Title = ({ children, isOpen }) => {
  return (
    <TitleWrapper>
      <h3>{renderLineBreaks(children)}</h3>
      {isOpen ? ChevronUp : ChevronDown}
    </TitleWrapper>
  );
};

export const SeoContentItem = ({ title, column1, column2, column3 }) => {
  const [isOpen, setIsOpen] = useState(false);
  const description = [column1, column2, column3];

  return (
    <SeoContentItemWrapper>
      <ContentWrapper isOpen={isOpen} onClick={() => setIsOpen(!isOpen)}>
        <Title isOpen={isOpen}>{title}</Title>
        <Description>
          {description &&
            description.map((item, index) => (
              <p key={`descriptionKey${index}`}>{renderLineBreaks(item)}</p>
            ))}
        </Description>
      </ContentWrapper>
    </SeoContentItemWrapper>
  );
};

export default SeoContentItem;
